export const blogPosts = [
  {
    id: 1,
    title: "Top 5 Halal Dishes to Try at Gyros Hero",
    date: "May 9, 2025",
    image:"/images/blog/fiveDishes.jpg" ,
    content: `
      If you're new to Gyros Hero, here are the must-try dishes that locals love:
      1. Chicken Over Rice – NYC-style with white and red sauce
      2. Hero Burger – Halal beef patty stacked with flavor
      3. Falafel Platter – Crispy, golden falafel served with hummus and pita
      4. Gyro Wrap – Sliced beef and lamb in a warm pita
      5. Philly Cheesesteak – Our halal twist on a classic American favorite
      
      Whether you're craving something light or filling, we’ve got it covered — all 100% halal.
    `
  },
  {
    id: 2,
    title: "Why Our Chicken Over Rice is Houston’s Favorite Lunch",
    date: "May 3, 2025",
    image:"/images/blog/chickenOverRice.jpg" ,
    content: `
      Our chicken over rice is inspired by NYC street carts but elevated for Houston tastes.
      We marinate our halal chicken overnight, grill it fresh to order, and serve it on fluffy basmati rice.
      What sets it apart? Our signature white garlic sauce and house red sauce — made in-house daily.
      
      This is the kind of meal that keeps our regulars coming back week after week.
    `
  },
  {
    id: 3,
    title: "Halal Catering for Offices in Houston – Gyros Hero Makes It Easy",
    date: "April 26, 2025",
    image:"/images/blog/catering.jpg" ,
    content: `
      Need to feed a hungry team at work? We offer simple and affordable halal catering options.
      Our Combo Platters, Chicken Over Rice trays, and Falafel boxes are perfect for corporate lunches.
      Delivery available across Houston — just contact us or order through our website.
      
      Trust Gyros Hero to bring authentic Mediterranean flavor to your next event!
    `
  }
];